(function () {
  const KEY = 'tomaz_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    updateCount();
  }

  function isWishlisted(handle) {
    return getWishlist().some(item => item.handle === handle);
  }

  function updateCount() {
    const count = getWishlist().length;

    document.querySelectorAll('.tomaz-wishlist-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function updateButtons() {
    document.querySelectorAll('.tomaz-wishlist-btn, .tomaz-wishlist-btn-product-icon').forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;

      btn.classList.toggle('is-active', isWishlisted(handle));
    });
  }

function showToast(item, message, type) {
  const toast = document.querySelector('.tomaz-wishlist-toast');
  if (!toast) return;

  const img = toast.querySelector('.tomaz-wishlist-toast-img');
  const title = toast.querySelector('.tomaz-wishlist-toast-title');
  const text = toast.querySelector('p');

  if (img) img.src = item.image || '';
  
  if (img) img.alt = item.title
  ? `${item.title} product image`
  : 'Wishlist product image';

  if (title) title.textContent = item.title || 'Product';
  if (text) text.textContent = message || 'Added to your wishlist.';

  toast.classList.remove('is-add', 'is-remove');
  toast.classList.add(type === 'remove' ? 'is-remove' : 'is-add');

  toast.hidden = false;

  clearTimeout(window.tomazWishlistToastTimer);
  window.tomazWishlistToastTimer = setTimeout(() => {
    toast.hidden = true;
  }, 3000);
}

  function addWishlist(item) {
    const items = getWishlist();

    if (!items.some(existing => existing.handle === item.handle)) {
      items.push(item);
      saveWishlist(items);
      showToast(item, 'Added to your wishlist.', 'add');
    }
  }

  function removeWishlist(handle) {
    const currentItems = getWishlist();
    const removedItem = currentItems.find(item => item.handle === handle);
    const items = currentItems.filter(item => item.handle !== handle);

    saveWishlist(items);

    return removedItem;
  }

  document.addEventListener('click', function (event) {
  const toast = event.target.closest('.tomaz-wishlist-toast');

  if (!toast) return;

  if (event.target.closest('.tomaz-wishlist-toast-close')) {
    toast.hidden = true;
    return;
  }

  window.location.href = '/pages/wishlist';
});  

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.tomaz-wishlist-btn, .tomaz-wishlist-btn-product-icon');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const item = {
      id: btn.dataset.productId,
      variant_id: btn.dataset.variantId,
      handle: btn.dataset.productHandle,
      title: btn.dataset.productTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice
    };

    if (!item.handle) return;

    if (isWishlisted(item.handle)) {
      const removedItem = removeWishlist(item.handle);

      if (removedItem) {
        showToast(removedItem, 'Removed from your wishlist.', 'remove');
      }
    } else {
      addWishlist(item);
    }

    updateButtons();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCount();
    updateButtons();
  });

  document.addEventListener('shopify:section:load', function () {
    updateCount();
    updateButtons();
  });

  window.TomazWishlist = {
    getWishlist,
    saveWishlist,
    updateCount,
    updateButtons
  };
})();